import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiLiftCabin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 6.35a1.012 1.012 0 0 0 1.29.59l2.65-.993V9.01H7.75c-.96 0-1.88.7-2.13 1.63-.83 3.18-.83 6.55 0 9.74.25.92 1.16 1.62 2.13 1.62h9.38c.95 0 1.88-.71 2.13-1.63.83-3.18.83-6.55 0-9.74-.24-.92-1.16-1.62-2.13-1.62h-3.69V5.198L16.8 3.94c.51-.2.77-.77.58-1.29-.2-.52-.77-.78-1.29-.59l-8.01 3c-.51.2-.77.77-.58 1.29ZM11.44 20v-2H7.184c.091.628.216 1.253.376 1.87.02.04.14.13.2.13h3.68Zm-4.428-4h4.428v-5H7.76c-.06 0-.18.09-.2.15A17.35 17.35 0 0 0 7.012 16Zm6.428 4v-2h4.264c-.09.623-.215 1.24-.374 1.85-.02.06-.14.15-.2.15h-3.69Zm0-4h4.438a17.458 17.458 0 0 0-.548-4.87c-.02-.04-.14-.13-.2-.13h-3.69v5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSkiLiftCabin;
